import { FC } from 'react'
import './step-tracker.css'

// COMPONENTS
import Step from './step'

// UTILITIES
import { flatten } from '@utils/string-helper'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    currentStep?: number
    steps?: number
    withMarginTop?: boolean
}

const StepTracker: FC<Props> = (props) => {
    const { className: classProps, currentStep = 1, steps = 3, withMarginTop = true, ...divProps } = props
    const className = flatten('horizontal', 'step-tracker', classProps)

    return (
        <div className={className} {...divProps} style={{ marginTop: withMarginTop ? '1.5rem' : undefined }}>
            {Array.from({ length: steps }, (_, index) => {
                const state = (index + 1) === currentStep ? 'active' : ((index + 1 < currentStep) ? 'complete' : 'inactive')
                return <Step key={index} state={state} />
            })}
        </div>
    )
}

export default StepTracker
